import { render, staticRenderFns } from "./OfficialVerification.vue?vue&type=template&id=77b0914b&"
import script from "./OfficialVerification.vue?vue&type=script&lang=js&"
export * from "./OfficialVerification.vue?vue&type=script&lang=js&"
import style0 from "./OfficialVerification.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports